module.exports = __webpack_public_path__ + "img/property-safety.d942b0ed.svg";